import React from 'react';
import { useIntl } from 'react-intl';
import { HeaderMenuItem } from './HeaderMenuItem';

type Props = {};

function HeaderMenu({}: Props) {
  const intl = useIntl();

  return (
    <>
      <div className="header-menu-container">
        <div className="header-menu">
          <HeaderMenuItem
            to="/dashboard"
            icon="element-11"
            title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
            fontIcon="bi-app-indicator"
          />
          <HeaderMenuItem to="/foodmenu" title="Food Menu" icon="coffee" fontIcon="bi-person" />
          <HeaderMenuItem to="/coupons" title="Coupons" icon="price-tag" fontIcon="bi-person" />
          <HeaderMenuItem to="/Orders" icon="handcart" title="Orders" fontIcon="bi-chat-left" />
          <HeaderMenuItem
            to="/TransactionTable"
            icon="bill"
            title="Transaction"
            fontIcon="bi-layers"
          />
          <HeaderMenuItem
            to="/contacts"
            icon="address-book"
            title="Contacts"
            fontIcon="bi-layers"
          />
        </div>
      </div>

      <style>{`
        .header-menu-container {
          display: flex;
          justify-content: center; /* Center the inner menu horizontally */
          align-items: center;
          width: 100%;
        }

        .header-menu {
          display: flex;
          justify-content: center; /* Ensure items are centered within this container */
          align-items: center;
          gap: 40px;
          max-width: 1200px; /* Limits width on large screens */
          width: 100%; /* Ensures it takes full available width up to max-width */
          padding: 0 20px; /* Adds padding for smaller screens */
        }

        /* Tablet screens (768px - 1024px) */
        @media (max-width: 1024px) and (min-width: 768px) {
          .header-menu {
            gap: 20px; /* Reduced gap for tablets */
            flex-wrap: wrap; /* Allows items to wrap if needed */
            justify-content: center;
          }
        }

        /* Mobile screens (< 768px) */
        @media (max-width: 767px) {
          .header-menu {
            flex-direction: column; /* Stack items vertically */
            gap: 15px; /* Smaller gap for mobile */
            padding: 10px;
          }
        }
      `}</style>
    </>
  );
}

export default HeaderMenu;